var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-end container",staticStyle:{"margin-top":"32px"}},[_c('OnboardingBtn',{staticStyle:{"margin-right":"16px"},attrs:{"text":"上一步","type":"plain","width":106},on:{"click":_vm.prev}}),_c('OnboardingBtn',{attrs:{"text":_vm.rightText || '下一步',"width":106,"disabled":_vm.disabled},on:{"click":_vm.next}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }